export default __webpack_public_path__ + "static/media/placeholder.7254b597.webp";